// src/globalComponents.js
import { createApp } from 'vue';
import Breadcrumb from './components/Breadcrumb.vue';

export function registerGlobalComponents(app) {
  app.component('Breadcrumb', Breadcrumb);
}
